<div class="dialogue-content">
  <div class="mat-dialogue-header">

    <h4 class="mat-dialog-title text-center text-white mb-4">
      Change Password
    </h4>

    <p class="text-center mb-3">
      Choose a new password that’s hard to guess and unique to this account.
    </p>

  </div>
  <form class="row gy-3 m-0" [formGroup]="changePassForm" (ngSubmit)="submitChangePassForm()" novalidate>
    <div class="col-lg-12">
      <label>Old Password<span class="text-danger">*</span></label>
      <mat-form-field class="w-100">
        <input matInput [type]="showOldPassword ? 'text' : 'password'" formControlName="oldPassword"
          placeholder="Enter old password" oninput="this.value = this.value.replace(/^\s+/g, '')"
          onpaste="return false" />
        <button mat-icon-button matSuffix type="button" (click)="togglePasswordVisibility('showOldPassword')">
          <img [src]="showOldPassword ? 'assets/images/eye.svg' : 'assets/images/eye-off.svg'" class="iconset" />
        </button>
      </mat-form-field>
      <mat-error *ngIf="isChangePassFormSubmitted && changePasswordFormControls['oldPassword'].hasError('required')"> Old password is required. </mat-error>
    </div>
    <div class="col-lg-12">
      <label>Create New Password<span class="text-danger">*</span></label>
      <mat-form-field class="w-100">
        <input matInput [type]="showNewPassword ? 'text' : 'password'" formControlName="newPassword"
          placeholder="Enter new password" oninput="this.value = this.value.replace(/^\s+/g, '')"
          onpaste="return false" />
        <button mat-icon-button matSuffix type="button" (click)="togglePasswordVisibility('showNewPassword')">
          <img [src]="showNewPassword ? 'assets/images/eye.svg' : 'assets/images/eye-off.svg'" class="iconset" />
        </button>
      </mat-form-field>
      <mat-error *ngIf="isChangePassFormSubmitted && changePasswordFormControls['newPassword'].hasError('required')"> 
        New password is required. 
      </mat-error> 
      <mat-error *ngIf="isChangePassFormSubmitted && changePasswordFormControls['newPassword'].hasError('pattern')"> 
        Password requires min 8 char, max 16 char, one upper case, one lower case, one special character, one number and no spaces.
      </mat-error>
    </div>
    <div class="col-lg-12">
      <label>Confirm New Password<span class="text-danger">*</span></label>
      <mat-form-field class="w-100">
        <input matInput [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmNewPassword"
          placeholder="Enter confirm new password" oninput="this.value = this.value.replace(/^\s+/g, '')"
          onpaste="return false" />
        <button mat-icon-button matSuffix type="button" (click)="togglePasswordVisibility('showConfirmPassword')">
          <img [src]="showConfirmPassword ? 'assets/images/eye.svg' : 'assets/images/eye-off.svg'" class="iconset" />
        </button>
      </mat-form-field>
      <mat-error *ngIf="isChangePassFormSubmitted && changePasswordFormControls['confirmNewPassword'].hasError('required')"> 
        Confirm new password is required. 
      </mat-error>
       <mat-error *ngIf="isChangePassFormSubmitted && changePassForm.hasError('mismatch') && changePassForm.get('confirmNewPassword')?.touched && !changePasswordFormControls['confirmNewPassword'].hasError('required')"> 
        New password and confirm password do not match. 
      </mat-error>
    </div>
    <mat-dialog-actions class="dialog-actions pt-4 p-0 d-flex justify-content-center gap-3">
      <button matButton="filled" type="button" class="dialog-btn-secondary px-4" mat-dialog-close
        (click)="close()">Cancel</button>
      <button matButton="filled" type="submit" class="dialog-btn-primary px-4">Update</button>
    </mat-dialog-actions>

  </form>
</div>